
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apply/artists",
      function () {
        return require("private-next-pages/apply/artists/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apply/artists"])
      });
    }
  